<template>
  <div class="cell-loader">
    <linear-loader />
  </div>
</template>

<script>
import linearLoader from './linear_loader'

export default {
  components: { linearLoader }
}
</script>

<style lang="scss" scoped>
.cell-loader {
  display: flex;
  position: relative;
  flex-grow: 1;
  height: 36px;
  align-items: center;
  padding: 0 16px;
  background-color: $or-white;
}
</style>
